import { useEffect, useCallback } from "react";
import "./App.css";
import Header from "./ui/Header";
import Months from "./ui/Months";
import Practicas from "./screens/Practicas";
import Reservar from "./screens/Reservar";
import ErrorScreen from "./screens/ErrorScreen";

import { useSelector } from "react-redux";

import { useTranslation } from "react-i18next";
import { hotjar } from "react-hotjar";

const App = () => {
  const [t, i18n] = useTranslation("global");
  const screen = useSelector((state) => state.screens.mainScreen);

  useEffect(() => {
    hotjar.initialize("2505763", 6);
    changeAppLanguage();
  }, []);

  const disableEscape = useCallback((event) => {
    const { charCode, keyCode, which } = event;
    var key = charCode || keyCode || which;
    if (key == 27) {
      event.preventDefault();
      return false;
    }
  }, []);

  useEffect(() => {
    window.addEventListener("keydown", disableEscape);
  }, [disableEscape]);

  const changeAppLanguage = () => {
    const search = new URLSearchParams(window.location.search).get("lang");

    let lang;

    if (search) {
      if (search === "en" || search === "EN") {
        lang = "en";
      } else if (search === "cat" || search === "CAT") {
        lang = "cat";
      } else {
        lang = "es";
      }
    } else {
      lang = "es";
    }

    i18n.changeLanguage(lang);
  };

  let renderScreen;

  if (screen === "practicas") {
    renderScreen = (
      <>
        <Header /> <Months /> <Practicas />
      </>
    );
  } else if (screen === "reservar") {
    renderScreen = <Reservar />;
  } else if (screen === "errorscreen") {
    renderScreen = <ErrorScreen />;
  }

  return <div className="container">{renderScreen}</div>;
};

export default App;
